import { createConsumer } from '@rails/actioncable';

const CHANNEL_NAME = 'Chatkit::ConversationChannel';
const EVENT_LIVE_AGENT_REQUESTED = 'live_agent_requested';
const EVENT_SESSION_EXPIRED = 'session_expired';

let consumer = null;
let subscription = null;

export const subscribeConversationChannel = (personId) => {
  if (subscription) return;
  if (!personId) return;

  if (!consumer) {
    consumer = createConsumer();
  }

  subscription = consumer.subscriptions.create(
    { channel: CHANNEL_NAME, person_id: personId },
    {
      received(data) {
        if (data.event === EVENT_LIVE_AGENT_REQUESTED) {
          document.dispatchEvent(new CustomEvent('chatkit.live-agent-request', { detail: data }));
        } else if (data.event === EVENT_SESSION_EXPIRED) {
          document.dispatchEvent(new CustomEvent('chatkit.session-expired', { detail: data }));
        }
      }
    }
  );
};

export const unsubscribeConversationChannel = () => {
  if (subscription) {
    subscription.unsubscribe();
    subscription = null;
  }
};
